<div class="At-Wrapper">
    <section class="At-SectionLogin">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-md-5 at_Mainlogin At-CustomCol-47 d-flex align-items-center justify-content-center">
                    <div class="At-LoginFormGeneral At-LoginFormVerifyEmail">
                       
                        <div class="At-ImgHolder At-ImgHolderLoginLogo">
                            <i class="icon-logo"></i>
                        </div>
                        <h2>Successful!</h2>
                        <h5>johnathan.smith@gmail.com</h5>
                        <div class="At-forgotContent">
                          <h5>Your email have been verfified. Now you can proceed 
                            ahead and complete your profile.</h5>
                        </div>
                        <div class="form-group">
                            <button class="At-Btn">GET STARTED </button>
                        </div>
                      
                    </div>
                </div>
                <!-- at_Mainlogin ends -->

                <div class="col-md-7 At-BannerLogin At-BannerForgot At-CustomCol-53 d-flex align-items-center justify-content-center">
                    <div class="At-ImgHolder">
                        <figure>
                            <img src="assets/images/verify-success-right-bg.png" class="img-fluid" alt="">
                        </figure>
                    </div>
                    <a class="At-GetMobileAppLink" href="javascript:void(0);">GET YOUR MOBILE APP   >></a>
                </div>
                <!-- At-BannerLogin ends -->
            </div>
        </div>
    </section>
</div>